import { ref as i, watch as l, onMounted as u, onUnmounted as a } from "vue";
const d = (s) => {
  const { elementRef: e, defaultStyle: o, callback: r } = s || {}, t = i(o), n = async () => {
    if (!e.value) {
      t.value = o;
      return;
    }
    t.value = r(e.value);
  };
  return l(
    () => e.value,
    () => {
      n();
    },
    { flush: "post" }
  ), u(() => {
    window.addEventListener("resize", n);
  }), a(() => {
    window.removeEventListener("resize", n);
  }), {
    style: t
  };
};
export {
  d as usePositionedStyle
};
